import { createFileRoute } from "@tanstack/react-router";
import {
  IndustryMarketingPage,
  industryMarketingHead,
  type IndustryFAQ,
} from "@/components/IndustryMarketingPage";

const FAQS: IndustryFAQ[] = [
  {
    "q": "How do local rental yards compete with national chains?",
    "a": "Category-specific pages, local Map Pack dominance, and same-day availability content. National chains win on scale; locals win on availability, price, and relationship. The site has to make those advantages visible."
  },
  {
    "q": "Is SEO worth it for equipment rental?",
    "a": "Yes — 'equipment rental near me' and category-specific searches are stable, high-intent, and underclaimed by locals. Most national chains spend on PPC but neglect SEO."
  },
  {
    "q": "Should rental yards run Google Ads?",
    "a": "Yes — especially for high-margin specialty rentals where national chains can't undercut you. We build category-targeted campaigns with proper tracking."
  },
  {
    "q": "Do you handle multi-yard rental businesses?",
    "a": "Yes — each yard gets its own location page, GBP, and local SEO so each ranks in its own Map Pack."
  },
  {
    "q": "What about specialty rentals (event, party, scaffolding)?",
    "a": "Specialty rentals are some of the highest-margin work in the industry and have lower competition. Specialty pages rank fast and book steady."
  }
];

export const Route = createFileRoute("/equipment-rental-marketing-colorado")({
  head: () =>
    industryMarketingHead("Equipment Rental", "equipment rental company", "equipment-rental-marketing-colorado", FAQS),
  component: () => (
    <IndustryMarketingPage
      industry={"Equipment Rental"}
      industryLower={"equipment rental company"}
      slug={"equipment-rental-marketing-colorado"}
      subheadline={"We help Colorado equipment rental companies — construction, party, specialty — drive direct bookings without depending on national rental aggregators."}
      painPoints={["Sunbelt and United Rentals dominate every search you should win","Walk-up customers find national chains instead of your local yard","Your website doesn't show your inventory in a way customers can act on"]}
      serviceDescriptions={{
        seo: "Rank for equipment rental, tool rental, party rental, scaffold rental, and every category across every Colorado market.",
        googleMaps: "Own 'equipment rental near me' in the Map Pack and beat national chain dominance.",
        webDesign: "Inventory-driven sites with category pages, real availability, and online booking that lets customers reserve before they call.",
        ppc: "Profitable Google Ads tuned to category and equipment-specific rental searches with strong ROAS.",
        geoAi: "Get cited when renters ask ChatGPT 'best equipment rental in Colorado Springs' or 'scaffold rental near me'.",
        socialMedia: "Inventory-led content that drives same-day rentals and builds repeat-customer awareness.",
      }}
      testimonial={{"quote":"We're winning rentals from local contractors who used to default to Sunbelt. Our inventory pages convert and the Map Pack works.","role":"Independent Rental Yard Owner","city":"Colorado Springs"}}
      faqs={FAQS}
      cityHubLinks={[{"to":"/colorado-springs","label":"Equipment rental marketing in Colorado Springs","description":"Compete with national chains across the Pikes Peak region."},{"to":"/denver-digital-marketing","label":"Equipment rental marketing in Denver","description":"Win contractor and event rentals across the Denver metro."},{"to":"/boulder-digital-marketing","label":"Equipment rental marketing in Boulder","description":"Construction and specialty rental across Boulder County."}]}
    />
  ),
});
